import { atom, selector } from "recoil"

export const defaultUsersListSmallWindow = []

const usersListSmallWindowAtom = atom({
  key: "usersListSmallWindowAtom",
  default: []
})

export const usersListSmallWindowSelector = selector({
  key: "usersListSmallWindowSelector",
  get: ({ get }) => {
    return get(usersListSmallWindowAtom)
  },
  set: ({ set }, usersListSmallWindow: string[]) => {
    set(usersListSmallWindowAtom, usersListSmallWindow)
  }
})
